import React from 'react';
import './ProcessPage.scss'; // Modular SCSS import for Process page
import ProcessHeader from '../sections/ProcessHeader/ProcessHeader';
import ProcessSteps from '../sections/ProcessSteps/ProcessSteps';
import ProcessQuality from '../sections/ProcessQuality/ProcessQuality';
import ProcessEquipment from '../sections/ProcessEquipment/ProcessEquipment';

const ProcessPage = () => {
  return (
    <>
      <ProcessHeader />
      <ProcessSteps />
      <ProcessQuality />
      <ProcessEquipment />
    </>
  );
};

export default ProcessPage;
